import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SubscriptionPlan } from '@vi-iot/client';

import { BookingStore, FLAT_RATE_BOOKING_TABS, InstallationsStore } from '@store';

@Component({
  selector: 'app-flat-booking',
  templateUrl: './flat-booking.component.html',
  styleUrls: ['./flat-booking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatBookingComponent implements OnInit, OnDestroy {
  @ViewChild('stepper', { static: false }) stepper: MatStepper;

  readonly subscriptionPlan = SubscriptionPlan;

  currentStep = FLAT_RATE_BOOKING_TABS.SELECT_PLAN;
  selectedPlan: SubscriptionPlan;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public bookingStore: BookingStore,
    public installationsStore: InstallationsStore,
    public route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.bookingStore.resetUserSelection();
    this.bookingStore.loadInstallations();
    this.bookingStore.loadBookingInstallation();
    this.bookingStore.getAllVitoguideSubscriptions();

    this.bookingStore.selectedPlan$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((plan) => {
      if (this.selectedPlan && !plan) {
        this.stepper.reset();
        this.cdRef.detectChanges();
      }
      this.selectedPlan = plan;
    });
  }

  nextStep(stepper: MatStepper): void {
    stepper.selected.completed = true;
    stepper.next();
  }

  initTrialStep(stepper: MatStepper): void {
    this.cdRef.detectChanges();
    // Postpone tab change due to animation problem
    setTimeout(() => {
      stepper.next();
    }, 300);
  }

  previousStep(stepper: MatStepper): void {
    stepper.selected.completed = false;
    stepper.previous();
  }

  initialStep(stepper: MatStepper): void {
    stepper.reset();
  }

  resetSelectedPlan(): void {
    this.bookingStore.selectPlan(null);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  createTrialSubscription(): void {
    this.bookingStore.createTrialSubscription();
  }
}
